import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { PageHeader, StatusBadge, Empty } from "../components/ui-helpers";
import { ArrowRight } from "@phosphor-icons/react";

export default function Approvals() {
  const [docs, setDocs] = useState([]);
  const [reqs, setReqs] = useState([]);
  const [nars, setNars] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/documents").then((r) => setDocs(r.data.filter((d) => ["review", "changes_requested"].includes(d.status))));
    api.get("/requirements").then((r) => setReqs(r.data));
    // narratives in review: derive from gaps endpoint is not it; fetch per requirement narratives via dashboard not available.
  }, []);

  // load narratives needing review by scanning requirement narratives
  useEffect(() => {
    if (reqs.length === 0) return;
    Promise.all(reqs.map((r) => api.get(`/narratives/${r.id}`).then((res) => res.data ? { ...res.data, req: r } : null).catch(() => null)))
      .then((list) => setNars(list.filter((n) => n && ["review", "changes_requested"].includes(n.status))));
  }, [reqs]);

  return (
    <div>
      <PageHeader title="Approvals" subtitle="Documents and RSAW narratives awaiting review" />
      <div className="p-8 space-y-8">
        <div>
          <h3 className="font-display font-bold text-lg mb-3">Documents in Review</h3>
          {docs.length === 0 ? <Empty title="Nothing to review" hint="No documents are currently in review." /> : (
            <div className="border border-border bg-card divide-y divide-border">
              {docs.map((d) => (
                <button key={d.id} data-testid={`approval-doc-${d.id}`} onClick={() => nav(`/documents/${d.id}`)} className="w-full flex items-center justify-between px-5 py-3 hover:bg-secondary/40 text-left">
                  <div className="flex items-center gap-3"><span className="font-medium">{d.title}</span><span className="text-xs capitalize text-muted-foreground">{d.doc_type}</span></div>
                  <div className="flex items-center gap-3"><StatusBadge status={d.status} /><ArrowRight size={16} /></div>
                </button>
              ))}
            </div>
          )}
        </div>

        <div>
          <h3 className="font-display font-bold text-lg mb-3">RSAW Narratives in Review</h3>
          {nars.length === 0 ? <Empty title="Nothing to review" hint="No narratives are currently in review." /> : (
            <div className="border border-border bg-card divide-y divide-border">
              {nars.map((n) => (
                <button key={n.id} data-testid={`approval-narrative-${n.requirement_id}`} onClick={() => nav(`/rsaw?req=${n.requirement_id}`)} className="w-full flex items-center justify-between px-5 py-3 hover:bg-secondary/40 text-left">
                  <span className="font-mono font-bold text-sm bg-primary text-primary-foreground px-2 py-0.5">{n.req.standard_id} {n.req.req_number}</span>
                  <div className="flex items-center gap-3"><StatusBadge status={n.status} /><ArrowRight size={16} /></div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
